import { register } from '../../../JavaScript/Utils'
import Splide from "@splidejs/splide";

export const VoicesCarousel = (el: HTMLElement) => {
  const sliderContainer: HTMLElement|null = el.querySelector('.splide-wrapper') as HTMLElement
  const sliderThumbnail: HTMLElement|null = el.querySelector('.splide-thumbnail') as HTMLElement

  if (sliderContainer && sliderThumbnail) {
    const main = new Splide( sliderContainer, {
      type: 'fade',
      autoHeight: true,
      pagination: false,
      arrows: false,
      drag: false
    } );

    const thumbnails = new Splide( sliderThumbnail, {
      rewind: true,
      autoWidth: true,
      autoHeight: true,
      drag: false,
      isNavigation: true,
      pagination: false,
      speed: 300,
      gap: '24px',
      padding: { left: 13 },
      breakpoints: {
        767: {
          gap: '8px',
          drag: true,
        },
      },
      i18n: {
        prev: el.dataset.translationPrev,
        next: el.dataset.translationNext,
        first: el.dataset.translationFirst,
        last: el.dataset.translationLast,
      },
      classes: {
        arrow: 'splide__arrow splide-arrow',
        prev: 'splide__arrow--prev splide-prev',
        next: 'splide__arrow--next splide-next',
      }
    } );

    const Components = thumbnails.Components;
    thumbnails.on( 'resized', function() {
      const isOverflow = Components.Layout.isOverflow();
      const list       = Components.Elements.list;
      const lastSlide  = Components.Slides.getAt( thumbnails.length - 1 );

      if ( lastSlide ) {
        // Toggles `justify-content: center`
        list.style.justifyContent = isOverflow ? '' : 'center';

        // Remove the last margin
        if ( ! isOverflow ) {
          lastSlide.slide.style.marginRight = '';
        }
      }
    } );

    main.sync( thumbnails );
    main.mount();
    thumbnails.mount();
  }
}

register('VoicesCarousel', VoicesCarousel)
